import React, {Fragment, useEffect, useState} from 'react';
import Challenges from "./Challenges";
import RutSerial from "./RutSerial";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import logo from "../images/logo.svg";
import logo_small from "../images/logo_small.svg";
import Loading from "./Loading";
import Typography from "@material-ui/core/Typography";
import RutSerialOnly from "./RutSerialOnly";
import ID_SC from "./ID_SC";
import {getMessage, loadMessages} from "../util";
import * as axios from "axios";


const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            display: 'flex',
            alignItems: 'left',
        },
        meeting_logo: {
            width: '100%'
        },
        logo: {
            marginTop:'20px',
            flexDirection: 'inherit'
        },
        right: {
            float: 'right',
            clear: 'right',
            width: '20px'
        }
    }
));


export default function MeetingSignIn(props) {


    const [challenges, setChallenges] = useState(null);
    const [loading, setLoading] = useState(true);
    const [meeting, setMeeting] = useState(null);
    const [messages, setMessages] = useState(null);



    const classes = useStyles();

    const meeting_id = 'bml90MyO';


    const loadMeeting = () => {

        axios({
            method: "get",
            url:
                process.env.REACT_APP_API_URL +
                "/meetings/" + meeting_id + "/base"
        })
            .then(response => {
                setLoading(false);

                const data = response.data;
                data.start_date = new Date(data.start_date);
                data.start_date = new Date(data.end_date);
                setMeeting(data);
                loadMessages(data.messages,(error,messages) => setMessages(messages));
            })
            .catch((error) => {
                console.log('ERROR',error);
                setLoading(false);
            });

    }

    useEffect(loadMeeting, []);


    return (
        <Fragment>
            {loading ? (
                <Loading/>
            ) : (meeting ? (
                    <Fragment>

                        <Container component="main" maxWidth="xs">
                            <br/>
                            <div className={classes.right} >
                                <img src={logo_small} alt="logo" />
                            </div>
                            <div className={classes.paper}>
                                <img src={meeting.logo} alt="logo" className={classes.meeting_logo}/>
                            </div>
                        </Container>

                        {meeting.authentication === 'serial' && <RutSerialOnly  meeting={meeting} messages={messages}/>}
                        {meeting.authentication === 'idonly' && <ID_SC meeting={meeting} messages={messages}/>}

                        {meeting.authentication === 'questions' && (challenges ? (
                            <Challenges setChallenges={setChallenges} meeting={meeting} challenges={challenges} messages={messages}
                                        />
                        ) : (
                            <RutSerial setChallenges={setChallenges} meeting={meeting} messages={messages}/>
                        ))
                        }
                    </Fragment>
                ) : (
                    <Typography variant="h5" component="h2">
                        <Container component="main" maxWidth="xs">
                            <div className={classes.paper}>
                                <img src={logo} alt="logo"/>
                            </div>
                        </Container>
                        {getMessage('default','meeting_not_found',messages)}
                    </Typography>
                )

            )}

        </Fragment>
    );
}